interface StepBadgeProps {
  step: number
}

export function StepBadge({ step }: StepBadgeProps) {
  return (
    <span className="inline-flex size-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-foreground">
      {step}
    </span>
  )
}
